<template>
  <div>
    <live-list v-show="tabType === 1" @handleShow="handleShow" />
    <share-details v-show="tabType === 2" @handleShow="handleShow" :rowItem="rowItem" />
  </div>
</template>

<script>
import liveList from './list.vue'
import shareDetails from './shareDetails.vue'
export default {
  components: { liveList, shareDetails },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>